// this file is automatically generated by generate-permissions.ts script
export const Permission = {
  Wildcard: '*',
  AutoPostAssetsFull: 'cloud-api/auto-post-assets.full',
  AutoPostAssetsRead: 'cloud-api/auto-post-assets.read',
  BatchesFull: 'cloud-api/batches.full',
  BatchesRead: 'cloud-api/batches.read',
  BatchesShare: 'cloud-api/batches.share',
  DashboardRead: 'cloud-api/dashboard.read',
  EmailLogsFull: 'cloud-api/email-logs.full',
  EmailLogsRead: 'cloud-api/email-logs.read',
  EmailMetricsRead: 'cloud-api/email-metrics.read',
  EmailSend: 'cloud-api/email.send',
  EnhancementVariantsFull: 'cloud-api/enhancement-variants.full',
  EnhancementVariantsRead: 'cloud-api/enhancement-variants.read',
  FileSpecificationsAudit: 'cloud-api/file-specifications.audit',
  FileSpecificationsFull: 'cloud-api/file-specifications.full',
  FileSpecificationsRead: 'cloud-api/file-specifications.read',
  FilenameConventionsAudit: 'cloud-api/filename-conventions.audit',
  FilenameConventionsFull: 'cloud-api/filename-conventions.full',
  FilenameConventionsRead: 'cloud-api/filename-conventions.read',
  MasterSuitesFull: 'cloud-api/master-suites.full',
  MasterSuitesPlaceholdersRead: 'cloud-api/master-suites.placeholders-read',
  MasterSuitesRead: 'cloud-api/master-suites.read',
  NotificationsFull: 'cloud-api/notifications.full',
  NotificationsRead: 'cloud-api/notifications.read',
  OrganizationsFull: 'cloud-api/organizations.full',
  OrganizationsProfileImage: 'cloud-api/organizations.profile-image',
  OrganizationsRead: 'cloud-api/organizations.read',
  OutputAssetsFull: 'cloud-api/output-assets.full',
  OutputAssetsRead: 'cloud-api/output-assets.read',
  OutputFormatsFull: 'cloud-api/output-formats.full',
  OutputFormatsRead: 'cloud-api/output-formats.read',
  OutputFormulasAudit: 'cloud-api/output-formulas.audit',
  OutputFormulasFull: 'cloud-api/output-formulas.full',
  OutputFormulasRead: 'cloud-api/output-formulas.read',
  OutputsCollectionsFull: 'cloud-api/outputs-collections.full',
  OutputsCollectionsRead: 'cloud-api/outputs-collections.read',
  PackagesFull: 'cloud-api/packages.full',
  PackagesRead: 'cloud-api/packages.read',
  PostAssetsExternalComment: 'cloud-api/post-assets.external-comment',
  PostAssetsFull: 'cloud-api/post-assets.full',
  PostAssetsInternalComment: 'cloud-api/post-assets.internal-comment',
  PostAssetsPreRelease: 'cloud-api/post-assets.pre-release',
  PostAssetsRead: 'cloud-api/post-assets.read',
  PostAssetsStatus: 'cloud-api/post-assets.status',
  PostAssetsExternalReview: 'cloud-api/post-assets.external-review',
  PostAssetsInternalReview: 'cloud-api/post-assets.internal-review',
  PostAssetsUpload: 'cloud-api/post-assets.upload',
  ProductDataFull: 'cloud-api/product-data.full',
  ProductDataRead: 'cloud-api/product-data.read',
  ProductDataFilenameConventionsFull: 'cloud-api/product-data-filename-conventions.full',
  ProductDataFilenameConventionsRead: 'cloud-api/product-data-filename-conventions.read',
  ProductReceivalsFull: 'cloud-api/product-receivals.full',
  ProductTouchesFull: 'cloud-api/product-touches.full',
  ProductsExportLabelData: 'cloud-api/products.export-label-data',
  ProductsDownloadWeightsAndMeasures: 'cloud-api/products.export-weights-and-measures',
  ProductsFull: 'cloud-api/products.full',
  ProductsLabelData: 'cloud-api/products.label-data',
  ProductsLifecycleFull: 'cloud-api/products.lifecycle-full',
  ProductsNotes: 'cloud-api/products.notes',
  ProductsDetailedStatus: 'cloud-api/products.detailed-status',
  ProductsProcessing: 'cloud-api/products.processing',
  ProductsRead: 'cloud-api/products.read',
  ProductsSummaryStatus: 'cloud-api/products.summary-status',
  ProductsViewLink: 'cloud-api/products.view-link',
  ProductsWorkflowFilter: 'cloud-api/products.workflow-filter',
  ProfilesSelfUpdate: 'cloud-api/profiles.self-update',
  SettingsFull: 'cloud-api/settings.full',
  SettingsRead: 'cloud-api/settings.read',
  ShopifyFull: 'cloud-api/shopify.full',
  ShootAssetsComment: 'cloud-api/shoot-assets.comment',
  ShootsFull: 'cloud-api/shoots.full',
  ShootAssetsDownload: 'cloud-api/shoot-assets.download',
  ShootAssetsFull: 'cloud-api/shoot-assets.full',
  ShootAssetsRead: 'cloud-api/shoot-assets.read',
  ShootAssetsReview: 'cloud-api/shoot-assets.review',
  SystemLogsFull: 'cloud-api/system-logs.full',
  TagsFull: 'cloud-api/tags.full',
  TagsRead: 'cloud-api/tags.read',
  UsersFilter: 'cloud-api/users.filter',
  UsersFull: 'cloud-api/users.full',
  UsersRead: 'cloud-api/users.read',
  VariantTouchAssetsRead: 'cloud-api/variant-touch-assets.read',
} as const;

export type PermissionType = (typeof Permission)[keyof typeof Permission];
